class WebHooks {

    constructor(firebase) {
      this.firebase = firebase;
    }

    call = (name, data = {}) => this.firebase.functions.httpsCallable(name)(data);

    sendSalesChannelNotification = (partnershipId, contractTimestamp) =>
      this.call('notifyCompanionPartnershipRegistrationV2', { partnershipId, contractTimestamp });
}

export default WebHooks;
